<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">好物兌換商品</div>
            <div class="breadcrumb-item">好物APP圖示設置-修改</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="100">
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>廣告名稱</span>
                                        </div>
                                        <Input v-model="form.name" style="width:100"/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
							    <Col span="25">
									<FormItem>
									    <div slot="label" class="form-label">
									    	<em class="red">* </em>
									        <span>圖片1</span>
									    </div>
									    <div class="form-upload-img">
									        <div class="img-preview" v-if="form.homepageimgOne">
									        	<!-- <Input v-model="form.homepageimgOne" style="width:100"/> -->
									            <img :src="form.homepageimgOne" alt="">
									        </div>
									        <Upload :before-upload="handleBeforeUploadOne"
									                accept="image/png, image/jpg, image/jpeg"
									                action="">
									            <div class="upload-btn">選擇圖片</div>
									        </Upload>
									        <div class="upload-tip">尺寸：1125px*2439px，格式：PNG、JPG</div>
									    </div>
									</FormItem>
							    </Col>
							</Row>
							
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>跳轉鏈結</span>
                                        </div>
                                        <Input v-model="form.url" style="width:100"/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>排序</span>
                                        </div>
                                        <Input v-model="form.sort" style="width:100"/>
                                    </FormItem>
                                </Col>
                            </Row>
							
                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">確定</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
				uploadFileOne: {
				    file: '',
				    base64: ''
				},
				uploadFileTwo: {
				    file: '',
				    base64: ''
				},
				editList: [],
                pageParam: {},
                pickRole: [],
                detail: {},
                isSubmiting: false,
                form: {
                    id: '',
					status: '',
					url: '',
					name: '',
					sort: '',
					homepageimgOne: '',
					homepageimgTwo: '',
					created_at: '',
                },
                homepageimg_one_id: '',
                homepageimg_two_id: '',
                homepageimg_one_sort: '',
                homepageimg_two_sort: '',
            };
        }, 
        mounted() {
            this.pageParam = this.$route.query;
			if(this.pageParam.id == undefined) {
				this.pageParam.id = 0;
			}
		    this.getDetail();
        },
        methods: {
            handleBack() {
                this.$router.go(-1);
            },
			handleBeforeUploadOne(file) {
			    this.uploadFileOne.file = file;
			    this.hanldeImgToBase64One();
			    return false;
			},
			hanldeImgToBase64One() {
			    let file = this.uploadFileOne.file;
			    let reader = new FileReader();
			    reader.readAsDataURL(file);
			    reader.onload = () => {
			        let _base64 = reader.result;
			        this.uploadFileOne.base64 = _base64;
			    };
				this.handleUploadImgOne();
			},
			handleUploadImgOne() {
			    this.isSubmiting = true;
			    let formData = new FormData();
			    formData.append('file', this.uploadFileOne.file);
			    formData.append('sort', this.homepageimg_one_sort);
			    formData.append('image_id', this.homepageimg_one_id);
			    this.$Rq.requestAuth({
			        url: this.$Api.advertiserManageEditImage,
			        method: 'post',
			        data: formData,
			        headers: {
			            'Content-Type': 'multipart/form-data',
			        }
			    }).then((res) => {
			        this.isSubmiting = false;
			        if (res.code == 0) {
			            this.form.homepageimgOne = res.data.path;
			        } else {
			            this.$Utils.showTipInfo(res.msg);
			        }
			    }).catch((err) => {
			        this.isSubmiting = false;
			    });
			},
			handleBeforeUploadTwo(file) {
			    this.uploadFileTwo.file = file;
			    this.hanldeImgToBase64Two();
			    return false;
			},
			hanldeImgToBase64Two() {
			    let file = this.uploadFileTwo.file;
			    let reader = new FileReader();
			    reader.readAsDataURL(file);
			    reader.onload = () => {
			        let _base64 = reader.result;
			        this.uploadFileTwo.base64 = _base64;
			    };
				this.handleUploadImgTwo();
			},
			handleUploadImgTwo() {
			    this.isSubmiting = true;
			    let formData = new FormData();
			    formData.append('file', this.uploadFileTwo.file);
			    formData.append('sort', this.homepageimg_two_sort);
			    formData.append('image_id', this.homepageimg_two_id);
			    this.$Rq.requestAuth({
			        url: this.$Api.advertiserManageEditImage,
			        method: 'post',
			        data: formData,
			        headers: {
			            'Content-Type': 'multipart/form-data',
			        }
			    }).then((res) => {
			        this.isSubmiting = false;
			        if (res.code == 0) {
			            this.form.homepageimgTwo = res.data.path;
			        } else {
			            this.$Utils.showTipInfo(res.msg);
			        }
			    }).catch((err) => {
			        this.isSubmiting = false;
			    });
			},
            getDetail() {
				if(this.pageParam.id != undefined) {
					this.$Rq.requestAuth({
					    url: this.$Api.advertiserManage,
					    method: 'get',
					    data: {
					    	id: this.pageParam.id
					    }
					}).then((res) => {
					    if (res.code == 0) {
					        let resData = res.data.data[0];
					        if(resData.status == 0) {
					        	resData.status = 2;
					        }
					        else if(resData.status == 1) {
					        	resData.status = 1;
					        }
					        this.form = {
					        	id: resData.id,
					        	name: resData.name,
					        	sort: resData.sort,
					        	status: resData.status,
					        	url: resData.url,
								created_at: resData.created_at,
								homepageimgOne: resData.homepageimg == null ? '- - -' : resData.homepageimg[0].path,
								homepageimgTwo: resData.homepageimg == null ? '- - -' : resData.homepageimg[1].path,
					        };
							this.uploadFileOne.base64 = resData.homepageimg[0].path;
							this.uploadFileTwo.base64 = resData.homepageimg[1].path;
							this.homepageimg_one_id = resData.homepageimg[0].id;
					        this.homepageimg_two_id = resData.homepageimg[1].id;
					        this.homepageimg_one_sort = resData.homepageimg[0].sort;
					        this.homepageimg_two_sort = resData.homepageimg[1].sort;
					    }
					});
				}
            },
            handleCheckForm() {
                let form = this.form;
                if (form.name == '') {
                    this.$Utils.showTipInfo('請輸入廣告名稱');
                    return;
                }
                if(form.status == ''){
                	this.$Utils.showTipInfo('請選擇開啟狀態');
                    return;
                }
				if (form.sort == '') {
				    this.$Utils.showTipInfo('請輸入排序');
				    return;
				}
				if (form.url == '') {
				    this.$Utils.showTipInfo('請輸入跳轉鏈結');
				    return;
				}
                this.handleSubmit();
            },
            handleSubmit() {
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.advertiserManageEdit,
                    method: 'post',
                    data: {
						id: this.pageParam.id,
						name: form.name,
						status: form.status,
						sort: form.sort,
						url: form.url,
                    }
                }).then((res) => {
                    this.isSubmiting = false;
                    if (res.code == 0) {
                        this.$Utils.showSuccess(res.msg);
                        this.getDetail();
                    } else {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "appbanneradvertiserManageEdit.scss";
</style>